import './cookieWallModal.scss';

class CookieWallModal {

    static ACCEPT_NECESSARY = '1';
    static ACCEPT_NECESSARY_GOOGLE = '2';
    static ACCEPT_ANALYTICAL_GOOGLE = '3';
    static ACCEPT_ADS_GOOGLE = '4';
    static ACCEPT_ANALYTICAL_UNUSED = '5';
    static ACCEPT_ANALYTICAL_HOTJAR = '6';

    constructor($scope, translateService, $element, close) {
        'ngInject';

        this.$scope = $scope;
        this.translate = translateService;
        this.closeCallback = close;
        this.$element =  $element;
        this.showMoreInformationAboutCookiesDescription = false;
        this.showCookieSettings = false;

        this.cookie_necessary = true;
        this.cookie_necessary_google = true;
        this.cookie_analytical_google = false;
        this.cookie_ads_google = false;
        this.cookie_analytical_unused = true;
        this.cookie_analytical_hotjar = false;
    }

    toggleMoreInformationAboutCookiesDescription() {
        this.showMoreInformationAboutCookiesDescription = !this.showMoreInformationAboutCookiesDescription;
    }

    toggleSettings() {
        this.showCookieSettings = !this.showCookieSettings;
    }

    rejectCookies() {
        this.cookie_necessary = false;
        this.cookie_necessary_google = false;
        this.cookie_analytical_google = false;
        this.cookie_ads_google = false;
        this.cookie_analytical_unused = true;
        this.cookie_analytical_hotjar = false;

        this.saveCookies();

        this.close();
    }

    acceptCookies(all) {
        this.cookie_necessary = true;
        this.cookie_necessary_google = true;

        if (all === true) {
            this.cookie_analytical_google = true;
            this.cookie_ads_google = true;
            this.cookie_analytical_unused = true;
            this.cookie_analytical_hotjar = true;
        }

        this.saveCookies();

        this.close();
    }

    saveCookies() {
        let acceptableCookies = [];

        let ANALYTICAL_GOOGLE = 'denied';
        let ADS_GOOGLE = 'denied';

        if (this.cookie_necessary) {
            acceptableCookies.push(CookieWallModal.ACCEPT_NECESSARY);
        }

        if (this.cookie_necessary_google) {
            acceptableCookies.push(CookieWallModal.ACCEPT_NECESSARY_GOOGLE);
        }

        if (this.cookie_analytical_google) {
            acceptableCookies.push(CookieWallModal.ACCEPT_ANALYTICAL_GOOGLE);

            ANALYTICAL_GOOGLE = 'granted';
        }

        if (this.cookie_ads_google) {
            acceptableCookies.push(CookieWallModal.ACCEPT_ADS_GOOGLE);

            ADS_GOOGLE = 'granted';
        }

        acceptableCookies.push(CookieWallModal.ACCEPT_ANALYTICAL_UNUSED);

        if (this.cookie_analytical_hotjar) {
            acceptableCookies.push(CookieWallModal.ACCEPT_ANALYTICAL_HOTJAR);
        }

        if (typeof (gtag) === 'function') {
            gtag('consent', 'update', {
                'ad_user_data': ADS_GOOGLE,
                'ad_personalization': ADS_GOOGLE,
                'ad_storage': ADS_GOOGLE,
                'analytics_storage': ANALYTICAL_GOOGLE
            });
        }

        if (ADS_GOOGLE === 'granted') {
            dataLayer.push({
                'event': 'cookie_consent_marketing'
            });
        }

        if (ANALYTICAL_GOOGLE === 'granted') {
            dataLayer.push({
                'event': 'cookie_consent_statistics'
            });
        }

        if (acceptableCookies.length > 0) {
            if (acceptableCookies.length === 6) {
                this.setCookie('acceptCookies', acceptableCookies, 30);
            } else {
                this.setCookie('acceptCookies', acceptableCookies, 0);
            }
        } else {
            this.setCookie('acceptCookies', '0', 0);
        }
    }

    setCookie(cname, cvalue, exdays) {
        if (exdays === 0) {
            document.cookie = cname + "=" + cvalue + ";path=/";
        } else {
            let d = new Date();
            d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
            let expires = "expires=" + d.toUTCString();

            document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
        }
    }

    close() {
        this.closeCallback(null);
    }
}

export default CookieWallModal;
